'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

exports.__esModule = true;
exports.flushTitle = flushTitle;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var titles = [];

function getTitle() {
  return titles[titles.length - 1];
}

function updateTitle() {
  document.title = getTitle();
}

function flushTitle() {
  var title = getTitle();
  titles = [];
  return title;
}

var Title = function (_React$Component) {
  _inherits(Title, _React$Component);

  function Title(props) {
    _classCallCheck(this, Title);

    _React$Component.call(this, props);

    this.state = {
      index: titles.push('') - 1
    };
  }

  Title.prototype.componentWillUnmount = function componentWillUnmount() {
    titles.pop();
  };

  Title.prototype.componentDidMount = function componentDidMount() {
    updateTitle();
  };

  Title.prototype.componentDidUpdate = function componentDidUpdate() {
    updateTitle();
  };

  Title.prototype.render = function render() {
    var render = this.props.render;
    titles[this.state.index] = typeof render === 'function' ? render(titles[this.state.index - 1] || '') : render;
    return this.props.children || null;
  };

  return Title;
}(_react2['default'].Component);

Title.propTypes = {
  render: _propTypes2['default'].string.isRequired
};
exports['default'] = Title;